// client/src/components/SearchForm.tsx
import React from 'react';
import Input from './ui/Input';
import Card from './ui/Card';

export interface SearchFormProps {
  jockey1: string;
  setJockey1: (value: string) => void;
  jockey2: string;
  setJockey2: (value: string) => void;
  boostedOdds: string;
  setBoostedOdds: (value: string) => void;
  racesToWin: number;
  setRacesToWin: (value: number) => void;
  applyBackOddsPercentage: boolean;
  setApplyBackOddsPercentage: (value: boolean) => void;
  backOddsPercentage: number;
  setBackOddsPercentage: (value: number) => void;
  loading: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  darkMode: boolean;
}

const SearchForm: React.FC<SearchFormProps> = ({
  jockey1,
  setJockey1,
  jockey2,
  setJockey2,
  boostedOdds,
  setBoostedOdds,
  racesToWin,
  setRacesToWin,
  applyBackOddsPercentage,
  setApplyBackOddsPercentage,
  backOddsPercentage,
  setBackOddsPercentage,
  loading,
  onSubmit,
  darkMode,
}) => {
  return (
    <Card className='p-4 sm:p-6'>
      <form onSubmit={onSubmit} className='space-y-6'>
        <div className='grid grid-cols-1 gap-6'>
          <Input
            label='Jockey 1'
            id='jockey1'
            value={jockey1}
            onChange={(e) => setJockey1(e.target.value)}
            required
            placeholder='Enter Jockey name'
          />
          <Input
            label='Jockey 2 (Optional)'
            id='jockey2'
            value={jockey2}
            onChange={(e) => setJockey2(e.target.value)}
            placeholder='Enter Jockey name'
          />
        </div>

        <Input
          label='Boosted Odds'
          id='boostedOdds'
          type='number'
          value={boostedOdds}
          onChange={(e) => setBoostedOdds(e.target.value)}
          placeholder='e.g., 2.80'
          step='0.01'
          min='1'
          inputMode='decimal'
          required
        />

        <div>
          <label
            htmlFor='racesToWin'
            className='block text-sm font-medium text-text-primary-light dark:text-text-primary-dark mb-1'
          >
            Races to Win: {racesToWin}
          </label>
          <input
            id='racesToWin'
            type='range'
            min='1'
            max='5'
            value={racesToWin}
            onChange={(e) => setRacesToWin(parseInt(e.target.value, 10))}
            className='w-full h-2 bg-surface-light dark:bg-surface-dark rounded-lg appearance-none cursor-pointer accent-white dark:accent-black'
          />
        </div>

        <div>
          <label className='text-sm font-medium text-text-primary-light dark:text-text-primary-dark mb-3 block'>
            Apply % to Back Odds
          </label>
          <div
            className='relative inline-flex backdrop-blur-sm rounded-lg p-1 border border-gray-300 dark:border-black'
            style={{ backgroundColor: darkMode ? '#000000' : '#f3f4f6' }}
          >
            <button
              type='button'
              onClick={() => setApplyBackOddsPercentage(false)}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${
                !applyBackOddsPercentage
                  ? 'bg-white dark:bg-slate-700/50 backdrop-blur-sm border border-gray-300 dark:border-black hover:bg-gray-50 dark:hover:bg-slate-600/50 transition-all duration-200 text-text-primary-light dark:text-white'
                  : 'text-text-primary-light dark:text-text-primary-dark hover:text-text-primary-light dark:hover:text-text-primary-dark'
              }`}
            >
              Off
            </button>
            <button
              type='button'
              onClick={() => setApplyBackOddsPercentage(true)}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${
                applyBackOddsPercentage
                  ? 'bg-white dark:bg-slate-700/50 backdrop-blur-sm border border-gray-300 dark:border-black hover:bg-gray-50 dark:hover:bg-slate-600/50 transition-all duration-200 text-text-primary-light dark:text-white'
                  : 'text-text-primary-light dark:text-text-primary-dark hover:text-text-primary-light dark:hover:text-text-primary-dark'
              }`}
            >
              On
            </button>
          </div>
        </div>

        {applyBackOddsPercentage && (
          <div>
            <label
              htmlFor='backOddsPercentage'
              className='block text-sm font-medium text-text-primary-light dark:text-text-primary-dark mb-1'
            >
              Back Odds Percentage: {backOddsPercentage}%
            </label>
            <input
              id='backOddsPercentage'
              type='range'
              min='10'
              max='20'
              step='2.5'
              value={backOddsPercentage}
              onChange={(e) =>
                setBackOddsPercentage(parseFloat(e.target.value))
              }
              className='w-full h-2 bg-surface-light dark:bg-surface-dark rounded-lg appearance-none cursor-pointer accent-white dark:accent-black'
            />
          </div>
        )}

        <button
          type='submit'
          disabled={loading}
          className='w-full px-6 py-3 text-base font-semibold text-[#2A7B9B] bg-transparent hover:bg-[#2A7B9B]/10 rounded-lg border border-[#2A7B9B]/50 backdrop-blur-sm transition-all duration-200 hover:shadow-lg hover:border-[#2A7B9B] disabled:opacity-50 disabled:cursor-not-allowed'
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </form>
    </Card>
  );
};

export default SearchForm;
